// Single Guide (CPT `guide`) — guarded so it only runs on single-guide.php.
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.single-guide');
    if (!root) {
        return;
    }

    // Плавный скролл по внутренним якорям контента гайда.
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var target = document.querySelector(link.getAttribute('href'));
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });
});
